import React from "react";

// Štampa liste formulara rizika: iste kolone kao na ekranu, bez akcija
// (isti obrazac kao štampa liste mapa procesa)
const FormulariRizikaListPrint = React.forwardRef((props, ref) => {
  const titles = [
    { id: 1, title: "Šifra procesa", width: "12%" },
    { id: 2, title: "Poslovni proces", width: "22%" },
    { id: 3, title: "Vlasnik procesa", width: "17%" },
    { id: 4, title: "Ime rizika", width: "22%" },
    { id: 5, title: "Odobrio", width: "13%" },
    { id: 6, title: "Datum izmene", width: "14%" },
  ];
  const cell = (index) => ({
    width: titles[index].width,
    padding: "5px",
    borderRight: index !== titles.length - 1 ? "1px solid black" : "none",
    overflowWrap: "anywhere",
  });
  return (
    <div
      ref={ref}
      style={{
        width: "98%",
        fontSize: "13px",
        marginTop: "10px",
        marginLeft: "auto",
        marginRight: "auto",
        color: "black",
      }}
    >
      <ul
        style={{
          display: "flex",
          fontWeight: "bold",
          border: "1px solid black",
          backgroundColor: "#F0F0F0",
        }}
      >
        {titles.map((el, index) => (
          <li
            key={el.id}
            style={{
              ...cell(index),
              // zaglavlja se prelamaju samo između reči
              overflowWrap: "normal",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {el.title}
          </li>
        ))}
      </ul>
      <ul>
        {(props.list || []).map((form) => (
          <li key={form.id}>
            <ul
              style={{
                display: "flex",
                borderLeft: "1px solid black",
                borderRight: "1px solid black",
                borderBottom: "1px solid black",
                pageBreakInside: "avoid",
              }}
            >
              <li style={cell(0)}>{form?.business_process_list?.code}</li>
              <li style={cell(1)}>{form?.business_process_list?.name}</li>
              <li style={cell(2)}>
                {form?.business_process_list?.business_process_owners?.map(
                  (owner) => (
                    <div key={owner.id}>
                      {owner.first_name} {owner.last_name}
                    </div>
                  )
                )}
              </li>
              <li style={cell(3)}>{form?.name}</li>
              <li style={cell(4)}></li>
              <li style={cell(5)}>
                {form.updated_at ? form.updated_at.split("T")[0] : ""}
              </li>
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
});

export default FormulariRizikaListPrint;
